<template>
    <div class="min-h-screen bg-black flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full bg-[#1A1A1A] rounded-lg shadow-lg p-8">
            <div @click="this.$router.push('/')" class="h-full flex justify-center items-center">
                    <img src="/favicon.ico" class="h-14" alt="">
                </div>
            <h2 class="mt-6 text-center text-2xl font-extrabold text-white">
                Connectez-vous à votre compte
            </h2>

            <form @submit.prevent="handleLogin" class="mt-8 space-y-6">
                <!-- Champ Username -->
                <div class="rounded-md shadow-sm -space-y-px">
                    <div class="mb-4 space-y-2">
                        <label for="username" class="block text-sm font-medium text-gray-300">
                            email
                        </label>
                        <input v-model="email" id="email" name="email" type="email" autocomplete="email"
                            required
                            class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-600 placeholder-gray-500 text-white bg-black focus:outline-none focus:ring-[#e6204b] focus:border-[#e6204b] focus:z-10 sm:text-sm"
                            placeholder="Entrez votre nom d'utilisateur" />
                    </div>

                    <!-- Champ Password -->
                    <div>
                        <label for="password" class="block text-sm font-medium mb-2 text-gray-300">
                            Mot de passe
                        </label>
                        <div class="relative">
                            <input v-model="password" :type="showPassword ? 'text' : 'password'" id="password"
                                name="password" autocomplete="current-password" required
                                class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-600 placeholder-gray-500 text-white bg-black focus:outline-none focus:ring-[#e6204b] focus:border-[#e6204b] focus:z-10 sm:text-sm"
                                placeholder="Entrez votre mot de passe" />
                            <button type="button" @click="showPassword = !showPassword"
                                class="absolute inset-y-0 right-1  flex items-center text-gray-400 hover:text-gray-300">
                                <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path
                                        d="M13.875 18.825c-4.5 1.35-7.95-1.725-9.225-4.35C3.075 11.4 6.45 8.325 12 7.2c2.55-.675 4.725-.375 6.45.675" />
                                    <path d="M3 3l18 18" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="3" />
                                    <path d="M3 12c1.5 4 6 7 9 7s7.5-3 9-7-6-7-9-7-7.5 3-9 7z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Bouton de connexion -->
                <div>
                    <button type="submit"
                        class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#e6204b] hover:bg-[#850A13] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e6204b] transition-all">
                        Connexion
                    </button>
                </div>

                <!-- Message d'erreur -->
                <div v-if="errorMessage" class="text-[#e6204b] text-sm mt-2">
                    {{ errorMessage }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    created() {
        localStorage.getItem("jwtToken") ? this.$router.back() : ""
    },
    data() {
        return {
            showPassword: false,
            email: "",
            password: "",
            errorMessage: "",
        };
    },
    methods: {
        handleLogin() {
            this.errorMessage = ""; // Réinitialise les messages d'erreur
            this.axios.post(this.$store.state.api + "/login", {
                email: this.email,
                password: this.password,
            }).then(({data}) => {
                localStorage.setItem('jwtToken',data.access_token.token)
                localStorage.setItem('type',data.user.type)
                this.$router.push('/reservations')
            }).catch(error => {
                this.errorMessage = "Impossible de se connecter " + error.data;
            })
        },
    },
};
</script>

<style scoped>
/* Ajout de transitions douces pour les hover */
button,
input {
    transition: all 0.3s ease-in-out;
}
</style>